const isDev = window &&
    window.location &&
    window.location.hostname === "localhost";

export default isDev;